import React from 'react';
import FeaturedArea from '../FeaturedArea/FeaturedArea';

const HomeBody = () => {
    return (
        <main className="container-brand">
           <FeaturedArea></FeaturedArea> 
        </main>
    );
};

export default HomeBody;